import {
  Box,
  Checkbox,
  IconButton,
  Stack,
} from "@mui/material";
import { CustomTextView } from "../../../../../component/CustomTextView";
import { STRINGS_FILTER } from "../../../../../../data/strings/Strings";
import { CloseRounded } from "@mui/icons-material";
import {
  COLOR_LESS_BLACK,
} from "../../../../../../data/colors/Colors";
import { FilteringCategory } from "../../../../../../domain/model/Category";
import { useState } from "react";
import { CustomCardView } from "../../../../../component/CustomCardView";
import { hasEnglishLetters } from "../../../../../../core/utils/Utils";

interface props {
  onClose: () => void;
  categories: Array<FilteringCategory>;
}

export function FilterView(p: props) {
  const [categories, setCategories] = useState<Array<FilteringCategory>>(
    p.categories
  );
  return (
    <Stack padding={2} spacing={2} width={300}>
      <Stack
        direction={"row"}
        alignItems={"center"}
        width={"100%"}
        justifyContent={"space-between"}
      >
        <CustomTextView text={STRINGS_FILTER} fontWeight="bold" variant="h6" />
        <Stack direction={"row"} alignItems={"center"}>
          <IconButton onClick={p.onClose}>
            <CloseRounded sx={{ color: COLOR_LESS_BLACK }} fontSize="medium" />
          </IconButton>
          <Checkbox
            style={{ color: COLOR_LESS_BLACK }}
            checked={
              categories.filter((c) => c.isSelected).length == categories.length
            }
            onChange={(
              e: React.ChangeEvent<HTMLInputElement>,
              checked: boolean
            ) => {
              e.stopPropagation();
              categories.map((c) => {
                c.isSelected = checked;
              });
              setCategories([...categories]);
            }}
          />
        </Stack>
      </Stack>

      {categories.map((category) => {
        return (
          <Box key={category._id}>
            <CustomCardView
              padding={1}
              children={
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  sx={{
                    direction: hasEnglishLetters(category.title ?? "")
                      ? "ltr"
                      : "rtl",
                  }}
                >
                  <Checkbox
                    style={{ color: COLOR_LESS_BLACK }}
                    checked={category.isSelected}
                    onChange={(
                      e: React.ChangeEvent<HTMLInputElement>,
                      checked: boolean
                    ) => {
                      e.stopPropagation();
                      categories.map((c) => {
                        if (c._id === category._id) {
                          c.isSelected = checked;
                        }
                      });
                      setCategories([...categories]);
                    }}
                  />
                  <CustomTextView
                    text={category.title}
                    fontWeight="300"
                    props={{
                      marginLeft: 1,
                    }}
                  />
                </Stack>
              }
            />
          </Box>
        );
      })}
    </Stack>
  );
}
